import { formatDate, getSearchParam } from "@/utils";
import { useNewsDetlCtrl, useNewsDetlHook } from "./hooks/useNewsDetl";
import parse from "html-react-parser";
import "./reset.scss";
import { useRecListCtrl, useRecListHook } from "./hooks/useRecList";
import classNames from "classnames";
import { useNewsListCtrl } from "@/components/NewsMain/Default/hooks/useNewsList";
import { Empty, Skeleton } from "antd-mobile";
import { logPageAccess } from "@/utils/logPageAccess";
import { scrollToTop } from "@/utils/scrollToTop";
import { nanoid } from "nanoid";
import { useNewsAdCpt as useAdCpt } from "@/hooks/adCpt/pageAds";
import { homeAtom } from "@/atoms/home";
import Teleport from "@/components/common/Teleport";
export default function NewsDetl() {
  const navigate = useNavigate();
  const { loadNewsDetl } = useNewsDetlHook();
  // 推荐新闻
  const { loadRecList } = useRecListHook();
  const {
    loadingDetl,
    isEmptyDetl,
    content,
    image,
    title,
    media,
    addtime,
    author,
    setNewsDetl,
    queryParams: query1,
  } = useNewsDetlCtrl();
  const { loadingRec, isEmptyRec, setRecList, queryParams: query2, recList } = useRecListCtrl();
  const { queryParams: query3, setNewsList } = useNewsListCtrl();
  const newsId = getSearchParam("id") || "";
  const [refreshId, setRefreshId] = useState(newsId);

  const fetchNewsDetailData = useSetAtom(homeAtom);
  useEffect(() => {
    fetchNewsDetailData(pathname);
  }, []);
  // end: 获取天气数据
  const initStates = (id: string, loading = false) => {
    setNewsDetl(prev => ({
      ...prev,
      loadingDetl: loading,
      content: "",
      image: "",
      title: "",
      media: "",
      addtime: "",
      author: "",
      queryParams: { ...query1, newsId: id },
    }));
    setRecList(prev => ({
      ...prev,
      loadingRec: loading,
      recList: [],
      queryParams: { ...query2, newsId: id },
    }));
  };
  useScrollCenter('div[data-path="/news"]');
  // 新闻详情
  useEffect(() => {
    if (newsId) {
      initStates(newsId, true);
    }
    return () => {
      initStates("", false);
    };
  }, []);

  useEffect(() => {
    if (query1.newsId) {
      loadNewsDetl();
      scrollToTop();
    }
    if (query2.newsId) {
      loadRecList();
    }
  }, [query1.newsId, query2.newsId]);
  const { pathname } = useLocation();
  const handleNewsDetail = (id: any) => {
    setRefreshId(id);
    initStates(id, true);
    navigate(`/news/detail?id=${id}`, {
      replace: false,
    });
    logPageAccess(pathname, isDevEnv);
  };
  const { $t } = useTranslate();
  function handleBackNewsList() {
    setNewsList(pre => ({
      ...pre,
      loadingNewsList: true,
      page: 1,
      total: 0,
      queryParams: {
        ...query3,
        page: 1,
      },
    }));
    navigate("/news");
  }

  const [advertIds, setAdvertIds] = useState<string[]>([]);
  const gennerateWrap = () => {
    const divToInsert = document.createElement("div");
    divToInsert.id = "_" + nanoid(16);
    setAdvertIds(pre => [...pre, divToInsert.id]);
    divToInsert.className = "center w-full my-10 google-ad-detail"; // 添加类名以便于样式控制
    return divToInsert;
  };
  // 计算字符数并插入div元素
  const insertDivsPeriodically = (node: any, interval = 600) => {
    let currentCharCount = 0;
    let lastInsertPosition = 0;

    function traverse(currentNode: any) {
      if (currentNode.nodeType === Node.TEXT_NODE) {
        // 累计文本字符数
        currentCharCount += currentNode.nodeValue?.length || 0;
      } else if (currentNode.nodeType === Node.ELEMENT_NODE) {
        // 先处理所有子节点
        for (let child of currentNode.childNodes) {
          traverse(child);
        }

        // 在块级元素结束时检查是否需要插入广告
        if (isBlockLevelElement(currentNode)) {
          if (currentCharCount - lastInsertPosition >= interval) {
            const div = gennerateWrap().cloneNode(true);
            currentNode.parentNode?.insertBefore(div, currentNode.nextSibling);
            lastInsertPosition = currentCharCount;
          }
        }
      }
    }

    function isBlockLevelElement(element: any) {
      const blockElements = [
        "DIV",
        "P",
        "H1",
        "H2",
        "H3",
        "H4",
        "H5",
        "H6",
        "UL",
        "OL",
        "LI",
        "SECTION",
        "ARTICLE",
        "HEADER",
        "FOOTER",
        "ASIDE",
        "BLOCKQUOTE",
        "PRE",
        "BR",
      ];
      return blockElements.includes(element?.tagName);
    }

    traverse(node);
  };
  useEffect(() => {
    if (!refreshId) {
      return;
    }
    setAdvertIds([]);
    const timer = setTimeout(() => {
      clearTimeout(timer);
      const container = document.querySelector(".rich-text");
      if (container) {
        insertDivsPeriodically(container, 600);
      }
    }, 2000);
  }, [refreshId]);
  return (
    <div className={classNames(["bg-[var(--app-bg-01)] pt-16 font-[Roboto,Roboto]"])}>
      <div data-position="position-43" className="mb-16">
        {useAdCpt("position-43", refreshId)}
      </div>
      {/* 新闻详情 */}
      {loadingDetl ? (
        <div className="px-16 pb-16">
          <Skeleton.Paragraph lineCount={20} animated />
        </div>
      ) : isEmptyDetl ? (
        <div className="center">
          <Empty className="py-150" imageStyle={{ width: 128 }} description="暂无数据" />
        </div>
      ) : (
        <div className="px-16">
          <div className="w-full h-240 rounded-10 mb-14">
            <img className="w-full h-240 rounded-10" src={image} alt="" />
          </div>
          <div className=" font-600 text-18 color-[var(--app-text-06)] mb-14">{title}</div>
          <div className="bg-[var(--app-bg-23)] w-full h-52 rounded-12 flex flex-col justify-between py-6 pl-17 mb-14">
            <div className="font-400 text-14 color-[var(--app-text-06)] lh-20">{author}</div>
            <div className="font-400 text-14 color-[var(--app-text-10)] lh-20">
              <i>{media}</i>
              <i> | </i>
              <i>{formatDate(Number(addtime))}</i>
            </div>
          </div>
          <div className="color-[var(--app-text-06)] rich-text mb-20">{parse(content)}</div>
        </div>
      )}
      {loadingRec ? (
        <div className="px-16 pb-16">
          <Skeleton.Paragraph lineCount={20} animated />
        </div>
      ) : isEmptyRec ? (
        <div className="center">
          <Empty className="py-150" imageStyle={{ width: 128 }} description="暂无数据" />
        </div>
      ) : (
        <div>
          {recList.map((it, idx) => (
            <div key={idx}>
              <Item1 it={it} formatDate={formatDate} handleNewsDetail={handleNewsDetail} />
              <div
                className={classNames([
                  "b-b-1 b-b-solid  mb-10",
                  idx != recList.length - 1 ? "b-b-[var(--app-border-02)]" : "b-b-transparent",
                ])}
              ></div>
            </div>
          ))}
        </div>
      )}
      {/* 返回 */}
      {!loadingRec && !isEmptyRec && (
        <div className="center">
          <div
            onClick={() => handleBackNewsList()}
            className="font-400 text-14 color-[var(--app-text-08)] lh-20 w-auto h-32 rounded-40  center my-20"
          >
            {$t("title59")}
          </div>
        </div>
      )}

      {advertIds.map(
        (id, idx) =>
          idx <= 2 && (
            <div key={id} data-position="position-44">
              <Teleport to={"#" + id}>{useAdCpt("position-44")}</Teleport>
            </div>
          ),
      )}
    </div>
  );
}
